jQuery.feature_import("js-NutrientGroups-react",
  () => import("./NutrientGroupsMain.js"),
  mod => mod.feature_js_NutrientGroups_react
);